<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12">
        <TitleAndSearch
          :icon="'icon_new_user'"
          :title="$t('fleet_management.persons.new_person.labels.title')"
          :showSearch="false"
        />
        <v-card>
          <div class="py-3 px-8">
            <h4 class="secondary--text font-weight-bold">
              {{ $t('fleet_management.persons.new_person.labels.card_title') }}
            </h4>
            <span class="text-caption font-italic">
              {{ $t('general.labels.required') }}
            </span>
          </div>
          <v-divider></v-divider>
          <v-form ref="form" v-model="valid" v-if="showForm">
            <v-container class="px-8 py-6">
              <PersonalDataInput
                :isNewPersonView="isNewPersonView"
                :hasRoleContactEmergency="hasRoleContact"
                :personalDataProp="{
                  personFirstName: first_name,
                  personLastName: last_name,
                  person,
                  personIdentificationType: identification_type,
                  personIdentificationNumber: identification_number,
                  errorMessage,
                  idNumberIsRequiredMessage,
                  identificationTypeIsRequiredMessage,
                  showMessageTypeInput,
                  showMessageNumberInput
                }"
                @personalDataDialogEmit="handlePersonalDataDialogUpdate"
                @personalDataEditEmit="handlePersonalDataEditUpdate"
                @emitValidData="handleValidationData"
              >
                <div class="tertiary--text text-body-2">
                  {{ labels.email }}
                </div>
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  :error-messages="errorMessage"
                  @change="checkEmail"
                  :error="personDuplicated"
                  filled
                  dense
                  required
                  color="tertiary"
                  id="idPersonasCorreo"
                ></v-text-field
              ></PersonalDataInput>
              <v-row>
                <v-col cols="12">
                  <hr class="divider-dotted" />
                </v-col>
              </v-row>
              <v-row
                dense
                class="my-5"
                v-for="(item, index) in rolles"
                :key="index"
              >
                <v-col cols="12" sm="12" md="4" lg="3" xl="2">
                  <div class="tertiary--text text-body-2">
                    {{ labels.role }}
                  </div>
                  <v-select
                    id="idPersonasInputRol"
                    @input="addRoleToItem(index, $event)"
                    :items="filteredRoles"
                    :value="item.rol"
                    item-text="text"
                    item-value="id"
                    @change="changeSetRoles"
                    :rules="[
                      v =>
                        !!v ||
                        $t(
                          'fleet_management.persons.new_person.rules.select_required'
                        )
                    ]"
                    dense
                    filled
                    required
                    color="tertiary"
                  >
                    <template v-slot:item="data">
                      <v-list-item__title
                        style="color: #2B2B2B; font-family: Lato, sans-serif; font-size: 13px;"
                        :id="
                          data.item.text === 'Usuario'
                            ? 'idPersonasUsuario'
                            : data.item.text === 'Contacto de emergencia'
                            ? 'idPersonasContactodeEmergencia'
                            : data.item.text === 'Conductor'
                            ? 'idPersonasConductor'
                            : data.item.text === 'Contacto'
                            ? 'idPersonasContacto'
                            : ''
                        "
                      >
                        {{ data.item.text }}
                      </v-list-item__title>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  lg="3"
                  xl="2"
                  v-if="item.rol === 1"
                >
                  <div class="tertiary--text text-body-2">
                    {{ labels.subProfile }}
                  </div>
                  <v-select
                    id="idPersonasPerfil"
                    v-model="item.profile"
                    :items="filteredProfiles"
                    item-text="text"
                    item-value="id"
                    :rules="[
                      v =>
                        !!v ||
                        $t(
                          'fleet_management.persons.new_person.rules.select_required'
                        )
                    ]"
                    dense
                    filled
                    required
                    color="tertiary"
                  >
                    <template v-slot:item="data">
                      <span
                        :id="
                          data.item.text === 'Monitoreo'
                            ? 'idPersonasMonitoreo'
                            : data.item.text === 'Administrador de Subflota'
                            ? 'idPersonasAdsf'
                            : data.item.text === 'Administrador'
                            ? 'idPersonasAdmin'
                            : ''
                        "
                      >
                        {{ data.item.text }}
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" v-if="showThingLimit(item)">
                  <v-row class="ma-0 pa-0">
                    <v-col cols="6" class="ma-0 pa-0">
                      <span class="tertiary--text text-body-2">{{
                        getThingLimitLabel(item)
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-col cols="6" class="ma-0 pa-0">
                    <v-autocomplete
                      id="idPersonasEntidades"
                      v-model="selectedThings"
                      return-object
                      filled
                      dense
                      :items="filteredThingsByLiveTrackingService"
                      multiple
                      chips
                      deletable-chips
                      item-text="name"
                      no-data-text="no hay info"
                      :loading="thingsLoading"
                      color="tertiary"
                      :error-messages="errorThingsSelected"
                    >
                      <template
                        v-slot:prepend-item
                        v-if="filteredThingsByLiveTrackingService.length > 0"
                      >
                        <v-list-item
                          id="idPersonasSeleccionEntidades"
                          ripple
                          @click="selectAll"
                        >
                          <v-list-item-action>
                            <v-icon>
                              {{ icon }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ 
                                $t(
                                'fleet_management.agents.agent_detail.partials.form_title_select_all'
                                )
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index < 3">
                          <span>{{ item.name }}</span>
                        </v-chip>
                        <span
                          v-else-if="index === 3"
                          class="grey--text caption"
                        >
                          (+{{ selectedThings.length - 3 }})
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-col>
                <template v-for="(contact, i) in item.rolContact">
                  <v-col
                    :key="i"
                    cols="12"
                    sm="12"
                    md="4"
                    lg="3"
                    xl="2"
                    :offset-sm="i > 0 ? '0' : '0'"
                    :offset-xl="i > 0 ? '2' : '0'"
                    :offset-md="i > 0 ? '3' : '0'"
                    v-if="item.rol === 3"
                  >
                    <div class="tertiary--text text-body-2">
                      {{ labels.phoneType }}
                    </div>
                    <v-select
                      :id="`idPersonasTipo${i}`"
                      v-model="contact.type"
                      :items="types"
                      item-text="text"
                      item-value="type"
                      :rules="[
                        v =>
                          !!v ||
                          $t(
                            'fleet_management.persons.new_person.rules.select_required'
                          )
                      ]"
                      dense
                      filled
                      required
                      color="tertiary"
                    ></v-select>
                  </v-col>
                  <v-col
                    v-if="item.rol === 3"
                    :key="i"
                    cols="12"
                    sm="12"
                    md="4"
                    lg="3"
                    xl="2"
                  >
                    <InputNumberPhone :phone="contact" :index="i" />
                  </v-col>
                  <v-col
                    :key="i"
                    cols="12"
                    sm="12"
                    md="3"
                    lg="2"
                    xl="2"
                    class="d-flex align-center justify-sm-center justify-md-start flex-nowrap"
                  >
                    <FmButton
                      v-if="item.rolContact.length > 2"
                      @click="removeContactEmergency(index, i)"
                      :button-text="'Eliminar'"
                      :type="'close'"
                    />
                  </v-col>
                  <v-col
                    cols="9 offset-3"
                    :key="i"
                    class="d-flex justify-start"
                  >
                    <FmButton
                      id="idPersonasAgregarNumeroContacto"
                      v-if="
                        i === item.rolContact.length - 1 &&
                          item.rol === 3 &&
                          i < 3
                      "
                      :color="'tertiary'"
                      :button-text="
                        $t(
                          'fleet_management.persons.new_person.labels.add_number_of_contact'
                        )
                      "
                      @click="addContactEmergency(index)"
                    />
                  </v-col>
                </template>
                <template v-if="item.rol === 4">
                  <v-col cols="12" sm="12" md="6" lg="4" xl="3">
                    <BaseDriver :item="item" />
                  </v-col>
                </template>
                <v-col cols="6" v-show="item.rol === 3">
                  <span class="tertiary--text text-body-2">
                    Entidades
                  </span>
                  <v-autocomplete
                    class="mt-2"
                    label="Entidades"
                    v-model="selectedThingsEmergencyContact"
                    return-object
                    filled
                    dense
                    :items="filteredThingsByLiveTrackingService"
                    multiple
                    chips
                    deletable-chips
                    item-text="name"
                    no-data-text="no hay info"
                    :loading="thingsLoading"
                    color="tertiary"
                    :error-messages="errorThingsSelectedEmergencyContact"
                  >
                    <template
                      v-slot:prepend-item
                      v-if="filteredThingsByLiveTrackingService.length > 0"
                    >
                      <v-list-item
                        ripple
                        @click="selectAllThingsEmergencyContact"
                      >
                        <v-list-item-action>
                          <v-icon>
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ 
                              $t(
                              'fleet_management.agents.agent_detail.partials.form_title_select_all'
                              )
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 3">
                        <span>{{ item.name }}</span>
                      </v-chip>
                      <span v-else-if="index === 3" class="grey--text caption">
                        (+{{ selectedThingsEmergencyContact.length - 3 }})
                      </span>
                    </template>
                  </v-autocomplete>
                  <div v-if="selectedThingsEmergencyContact.length >= 4">
                    <h4 class="red--text text-body-2 font-weight-normal">
                      {{
                        $t(
                          'fleet_management.persons.person_info.labels.card_field_priority_first_three_vehicles'
                        )
                      }}
                    </h4>
                  </div>
                </v-col>
                <v-col class="d-flex justify-end">
                  <FmButton
                    v-show="rolles.length >= 2"
                    :button-text="'Eliminar Rol'"
                    @click="removeRol(index)"
                    :type="'close'"
                  />
                </v-col>
                <v-col cols="12">
                  <hr class="divider-dotted" />
                </v-col>
              </v-row>
              <v-row dense>
                <v-col class="d-flex justify-start" v-if="!hideButtonAddRole">
                  <FmButton
                    :color="'tertiary'"
                    v-show="rolles.length < 3"
                    @click="addRol(index)"
                    :button-text="
                      $t('fleet_management.persons.new_person.labels.add_rol')
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex justify-space-between">
                  <v-btn
                    @click="cancel"
                    outlined="true"
                    color="secondary"
                    rounded
                    >{{
                      $t(
                        'fleet_management.persons.new_person.labels.card_newperson_cancel_button'
                      )
                    }}</v-btn
                  >
                  <v-btn
                    id="idBtnPersonasGuardar"
                    class="ml-2"
                    color="tertiary white--text"
                    :disabled="!valid || isFormValid || personDuplicated"
                    rounded
                    :loading="loading"
                    @click="savePerson()"
                    >{{
                      $t(
                        'fleet_management.persons.new_person.labels.card_newperson_save_button'
                      )
                    }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
            <v-dialog
              v-model="dialogName"
              persistent
              max-width="500px"
              transition="dialog-transition"
            >
              <v-card class="dialog-attention">
                <v-card-title class="orange--text">
                  <SvgIcon class="orange--text" iconType="icon_attention" />
                  {{
                    $t('fleet_management.persons.new_person.alerts.attention')
                  }}
                  <v-spacer></v-spacer>

                  <v-btn icon @click="dialogName = false">
                    <SvgIcon class="secondary--text" iconType="icon_close" />
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="secondary--text headline"
                  >{{
                    $t(
                      'fleet_management.persons.new_person.errors.person_match'
                    )
                  }}:</v-card-text
                >
                <v-card-text class="secondary--text"
                  >{{ repeatPersons.first_name }}
                  {{ repeatPersons.last_name }}</v-card-text
                >
                <v-card-text class="tertiary--text">{{
                  repeatPersons.emails[0].email
                }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-form>
          <div v-else>
            <v-row>
              <v-col cols="12">
                <h2 class="secondary--text text-center mt-9">
                  {{
                    $t(
                      'fleet_management.persons.new_person.alerts.person_created'
                    )
                  }}
                </h2>
              </v-col>
              <v-col>
                <h4 class="secondary--text text-center">
                  {{ this.first_name }} {{ this.last_name }}
                </h4>
              </v-col>
              <v-col cols="12" class="d-flex justify-center px-7 my-16">
                <v-btn
                  outlined="true"
                  color="secondary"
                  rounded
                  @click="viewPersonDetail()"
                  >{{
                    $t(
                      'fleet_management.persons.new_person.labels.card_personcreated_action_detail_button'
                    )
                  }}</v-btn
                >
                <v-btn
                  class="ml-2"
                  color="tertiary white--text"
                  rounded
                  @click="goBack()"
                  >{{
                    $t(
                      'fleet_management.persons.new_person.labels.card_personcreated_action_list_button'
                    )
                  }}</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-card>
        <v-snackbar
          v-model="snack"
          :timeout="snackBarTimeout"
          :color="snackColor"
        >
          {{ snackText }}

          <template v-slot:action="{ attrs }">
            <v-btn v-bind="attrs" text @click="snack = false">
              {{
                $t(
                  'fleet_management.persons.new_person.labels.card_snackbar_close_button'
                )
              }}
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
    <Dialog
      :closeButtonText="dialog.closeButtonText"
      @cancelButtonPressed="showDialog = false"
      :oneButton="dialog.oneButton"
      @oneButtonAction="cancelDialog"
      :oneButtonText="dialog.oneButtonText"
      :showDialog="showDialog"
      @submitButtonPressed="cancelGeofence"
      :submitButtonText="dialog.acceptButtonText"
      :text="dialog.text"
      :type="dialog.type"
    />
  </v-container>
</template>

<script>
import { FirebaseTagNames } from '@leapsight/portal'
import TitleAndSearch from '@/components/TitleAndSearch.vue'
import { i18n } from '@leapsight/portal'
import { mapGetters } from 'vuex'
import { PersonsHelpers, ThingsHelpers } from '@/helpers/mainExports'
import { Person } from '@/helpers/objects'
import {
  SNACKBAR_TIMEOUT,
  SvgIcon,
  firebaseServices
} from '@leapsight/styleguide'
import Dialog from '@/components/dialog/Dialog'
import InputNumberPhone from '@/components/persons/contactEmergency/InputNumberPhone.vue'
import store from '@/store'
import PersonalDataInput from '@/components/persons/PersonalDataInput.vue'
import FmButton from '@/share/components/FmButton.vue'
import BaseDriver from '@/components/persons/Driver/BaseDriver.vue'

export default {
  components: {
    BaseDriver,
    PersonalDataInput,
    TitleAndSearch,
    FmButton,
    SvgIcon,
    Dialog,
    InputNumberPhone
  },
  filters: {
    filterRol(val) {
      return val
    }
  },
  async created() {
    if (Boolean(this.getThings.length)) {
      this.thingsLoading = false
    } else {
      await this.$store.dispatch('things/getThingsList')
      this.thingsLoading = false
    }
  },
  data() {
    return {
      showMessageTypeInput: false,
      showMessageNumberInput: false,
      isFormValid: false,
      identificationTypeIsRequiredMessage: '',
      idNumberIsRequiredMessage: '',
      snackColor: '',
      snackBarTimeout: SNACKBAR_TIMEOUT,
      thingsLoading: true,
      selectedThings: [],
      selectedThingsEmergencyContact: [],
      types: [
        { type: 'mobile', text: 'Movil' },
        { type: 'home', text: 'Fijo' },
        { type: 'work', text: 'Trabajo' },
        { type: 'other', text: 'Otro' }
      ],
      labels: {
        email: i18n.t(
          'fleet_management.persons.new_person.labels.card_field_mail'
        ),
        role: i18n.t(
          'fleet_management.persons.new_person.labels.card_field_role'
        ),
        subProfile: i18n.t(
          'fleet_management.persons.new_person.labels.card_subtitle_profile'
        ),
        phoneType: 'Tipo'
      },
      type: '',
      rolles: [
        { rol: '', profile: '', rolContact: [{ type: 'mobile', number: '' }] }
      ],
      rolContact: [{ type: 'mobile', number: '' }],
      loading: false,
      errorMessage: '',
      identification_number: '',
      identification_type: '',
      person: {},
      showForm: true,
      snack: false,
      first_name: '',
      last_name: '',
      email: '',
      rol: '',
      profile: '',
      roles: [
        {
          id: 1,
          text: i18n.t(
            'fleet_management.persons.new_person.labels.card_data_role_user'
          )
        },
        {
          id: 3,
          text: 'Contacto de emergencia'
        },
        {
          id: 4,
          text: 'Conductor'
        },
        {
          id: 2,
          text: 'Contacto'
        }
      ],
      profiles: [
        {
          id: 1,
          text: i18n.t(
            'fleet_management.persons.new_person.labels.card_data_profile_monitor'
          )
        },
        {
          id: 3,
          text: i18n.t(
            'fleet_management.persons.new_person.labels.card_data_profile_fleet_admin'
          )
        },
        {
          id: 2,
          text: i18n.t(
            'fleet_management.persons.new_person.labels.card_data_profile_admin'
          )
        }
      ],
      nameRules: [
        v =>
          !!v || i18n.t('fleet_management.persons.person_info.rules.required'),
        v =>
          (v && v.length <= 25) ||
          i18n.t('fleet_management.persons.person_info.rules.character_length'),
        v =>
          (v && v.length >= 2) ||
          i18n.t('fleet_management.persons.person_info.rules.character_length'),
        v =>
          /[\w+À-ÿñÑ\s]{0,25}([^@;,])$/gi.test(v) ||
          i18n.t('fleet_management.agents.create.errors.invalid_name')
      ],
      emailRules: [
        v =>
          !!v ||
          i18n.t('fleet_management.persons.new_person.rules.mail_required'),
        v =>
          /.+@.+\..+/.test(v) ||
          i18n.t('fleet_management.persons.new_person.rules.mail_format')
      ],
      rules: {
        contactIdNumber: v =>
          !!v ||
          i18n.t(
            'fleet_management.persons.new_person.rules.id_number_required'
          ),
        contactIdentificationType: v =>
          !!v ||
          i18n.t('fleet_management.persons.new_person.rules.select_required')
      },
      dialog: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButton: false,
        oneButtonText: ''
      },
      dialogDefault: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButton: false,
        oneButtonText: ''
      },
      showDialog: false,
      dialogName: false,
      valid: false,
      personDuplicated: false,
      repeatPersons: {
        emails: [
          {
            email: ''
          }
        ]
      },
      hideButtonAddRole: false,
      isNotRepetNumber: false,
      errorThingsSelected: 'Debe seleccionar al menos una entidad',
      errorThingsSelectedEmergencyContact: ''
    }
  },
  methods: {
    handleValidationData(isValid) {
      this.isFormValid = isValid
    },
    showThingLimit(item) {
      return item.rol === 1 && (item.profile === 1 || item.profile === 3)
    },
    getThingLimitLabel(item) {
      if (item.profile === 1) {
        return i18n.t(
          'fleet_management.persons.persons.labels.title_limit_view_entities'
        )
      } else if (item.profile === 3) {
        return i18n.t(
          'fleet_management.persons.persons.labels.title_limit_view_entities_for_fleet'
        )
      } else {
        return ''
      }
    },
    handlePersonalDataDialogUpdate(data) {
      const { repeatPersons, dialogName } = data
      this.repeatPersons = repeatPersons
      this.dialogName = dialogName
    },
    handlePersonalDataEditUpdate(data) {
      const {
        personIdentificationType,
        personIdentificationNumber,
        personFirstName,
        personLastName
      } = data

      this.first_name = personFirstName
      this.last_name = personLastName
      this.identification_type = personIdentificationType
      this.identification_number = personIdentificationNumber
    },
    onErrorMessageForContactEmergencyFields() {
      this.identificationTypeIsRequiredMessage = !this.identification_type
        ? 'El tipo de documento es requerido para contactos de emergencia'
        : ''
      this.idNumberIsRequiredMessage = !this.identification_number
        ? 'El número de documento es requerido para contactos de emergencia'
        : ''
      this.showMessageTypeInput = !this.identification_type
      this.showMessageNumberInput = !this.identification_number
    },
    offErrorMessageForContactEmergencyFields() {
      this.identificationTypeIsRequiredMessage = ''
      this.idNumberIsRequiredMessage = ''
      this.showMessageTypeInput = false
      this.showMessageNumberInput = false
    },
    changeSetRoles(rol) {
      if (rol === PersonsHelpers.ROL_ID.contact && this.rolles.length < 2) {
        this.rolles[0].rolContact = []
        this.hideButtonAddRole = true
        return
      }
      if (rol !== PersonsHelpers.ROL_ID.contact && this.rolles.length < 2) {
        this.hideButtonAddRole = false
        return
      }
    },
    addRoleToItem(index, val) {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.INP_FLEET_MANAGEMENT_ADD_ROL
      )

      this.rolles[index].rol = val
      if (val === PersonsHelpers.PROFILE_ID.emergencyContact) {
        this.onErrorMessageForContactEmergencyFields()
        this.rolles[index].profile = PersonsHelpers.PROFILE_ID.emergencyContact
        this.rolles[index].rolContact = [
          { type: 'mobile', number: '' },
          { type: 'mobile', number: '' }
        ]
      }
      if (val === PersonsHelpers.PROFILE_ID.user) {
        this.offErrorMessageForContactEmergencyFields()
        this.$refs.form.resetValidation()
        this.rolles[index].profile = ''
        this.rolles[index].rolContact = []
      }
      if (val === PersonsHelpers.PROFILE_ID.driver) {
        this.offErrorMessageForContactEmergencyFields()
        this.$refs.form.resetValidation()
        this.rolles[index].ibutton = ''
        this.rolles[index].rolContact = []
      }

      for (let idx = 0; idx < this.roles.length; idx++) {
        const hasRole = this.rolles.some(rol => rol.rol == this.roles[idx].id)
        if (hasRole) {
          this.roles[idx].disabled = true
        } else {
          this.roles[idx].disabled = false
        }
      }

      if (val === PersonsHelpers.ROL_ID.contact) {
        this.roles[0].disabled = false
        this.roles[1].disabled = false
        this.roles[2].disabled = false
      }
    },
    addRol() {
      const newRol = {
        rol: '',
        profile: '',
        rolContact: [{ type: 'mobile', number: '' }],
        ibutton: ''
      }
      this.rolles.push(newRol)
    },
    removeContactEmergency(rol, i) {
      this.rolles[rol].rolContact.splice(i, 1)
    },
    removeRol(idx) {
      this.offErrorMessageForContactEmergencyFields()
      const rol = this.rolles.splice(idx, 1)[0].rol
      if (Boolean(rol)) {
        this.roles.find(r => r.id == rol).disabled = false
        if (rol === PersonsHelpers.ROL_ID.user) {
          this.selectedThings = []
          this.selectedThingsEmergencyContact = []
        }
      }
    },
    addContactEmergency(rol) {
      this.rolles[rol].rolContact.push({ type: 'mobile', number: '' })
    },
    goBack() {
      this.$router.go(-1)
    },
    checkName() {
      const name = this.first_name.replace(/\s+$/, '').toLowerCase()
      const lastName = this.last_name.replace(/\s+$/, '').toLowerCase()
      if (name !== '' && lastName !== '') {
        const persons = this.getPersons
        for (let index = 0; index < persons.length; index++) {
          const element = persons[index]
          if (
            element.first_name.toLowerCase() === name &&
            element.last_name.toLowerCase() === lastName
          ) {
            this.repeatPersons = element
            this.dialogName = true
          }
        }
      }
    },
    checkEmail() {
      const mail = this.email
      if (mail !== '') {
        const persons = this.getPersons
        let emailUsed
        this.personDuplicated = false
        this.errorMessage = ''
        for (let index = 0; index < persons.length; index++) {
          const element = persons[index]
          const personEmailArr = element.email
          if (typeof personEmailArr !== 'undefined')
            emailUsed = personEmailArr.some(
              item => item.email.toLowerCase() === mail.toLowerCase()
            )

          if (emailUsed) {
            this.repeatPersons = element
            this.dialogName = true
            this.personDuplicated = true
            this.errorMessage = i18n.t(
              'fleet_management.persons.new_person.errors.mail_match'
            )
            break
          }
        }
      }
    },
    onErrorIdentificationTypeRequired() {
      const hasPersonIdentifyType = Boolean(this.identification_type)
      const hasPersonIdenrtifyNumber = Boolean(this.identification_number)
      if (!hasPersonIdentifyType && hasPersonIdenrtifyNumber) {
        this.identificationTypeIsRequiredMessage =
          'El tipo de documento es requerido.'
        this.showMessageTypeInput =
          !hasPersonIdentifyType && hasPersonIdenrtifyNumber
      }
      return !hasPersonIdentifyType && hasPersonIdenrtifyNumber
    },
    savePerson() {
      this.$store.commit('setNumberCheck', this.checkSingleNumberPhones)

      if (this.onErrorIdentificationTypeRequired()) return

      if (this.$refs.form.validate() && !this.$store.state.numberCheck) {
        this.loading = true
        const payload = {
          firstName: this.first_name.replace(/\s+$/, ''),
          lastName: this.last_name.replace(/\s+$/, ''),
          email: this.email.replace(/\s+$/, ''),
          rol: this.rolles,
          identificationNumber: this.identification_number,
          identificationType: this.identification_type
        }

        const newPerson = PersonsHelpers.prepareForStore(payload)

        PersonsHelpers.createPerson(newPerson)
          .then(async response => {
            this.person = response.args[0]

            store.dispatch('persons/updatePerson', {
              uriId: this.person.id,
              firstName: this.person.first_name,
              lastName: this.person.last_name,
              identifyType: this.person.identification_type,
              identifyNumber: this.person.identification_number,
              phonesIn: PersonsHelpers.getPhones(this.person)
            })

            if (this.selectedThings.length) {
              try {
                await PersonsHelpers.thingAssignmentsAdd(
                  this.person.id,
                  this.selectedThings
                )
              } catch (e) {
                this.snack = true
                this.snackColor = 'error'
                this.snackText = i18n.t(
                  'fleet_management.persons.new_person.errors.person_created'
                )
              }
            }
            await this.createContactEmergencyFromPerson()

            this.loading = false
            this.showForm = false
            this.snack = true
            this.snackColor = 'success'
            this.snackText = i18n.t(
              'fleet_management.persons.new_person.alerts.person_created'
            )
          })
          .catch(error => {
            this.loading = false
            if (error.kwargs.code === 'already_exists') {
              this.errorMessage = i18n.t(
                'fleet_management.persons.new_person.errors.mail_match'
              )
            }
            this.snack = true
            this.snackColor = 'error'
            this.snackText = i18n.t(
              'fleet_management.persons.new_person.errors.person_created'
            )
          })
      }

      setTimeout(() => {
        this.$store.commit('setNumberCheck', false)
      }, 5000)
    },
    cancel() {
      this.showDialog = true
      this.dialog.type = 'warning'
      this.dialog.text = i18n.t(
        'fleet_management.persons.new_person.alerts.data_confirmation'
      )
      this.dialog.closeButtonText = i18n.t(
        'fleet_management.geofences.create_geofence.alerts.card_cancel_button'
      )
      this.dialog.acceptButtonText = i18n.t(
        'fleet_management.geofences.create_geofence.alerts.card_accept_button'
      )
    },
    cancelDialog() {
      this.showDialog = false
      Object.assign(this.dialog, this.dialogDefault)
    },
    cancelGeofence() {
      this.$router.push({ name: 'PersonsList' })
    },
    viewPersonDetail() {
      const id = PersonsHelpers.getPersonId(this.person)
      const created_by = this.person.created_by
      const uriId = this.person.id
      const first_name = this.person.first_name
      const last_name = this.person.last_name
      const account_id = this.person.account_id
      const identification_number = this.person.identification_number
      const identification_type = this.person.identification_type
      const roles = PersonsHelpers.getRoles(this.person)
      const emails = PersonsHelpers.getPersonEmail(this.person)
      const profile = PersonsHelpers.getProfile(this.person)
      const phones = PersonsHelpers.getPhones(this.person)
      const ibutton = PersonsHelpers.getIbutton(this.person)

      const newPerson = new Person({
        id,
        created_by,
        uriId,
        first_name,
        last_name,
        identification_type,
        identification_number,
        account_id,
        roles,
        emails,
        profile,
        phones,
        ibutton
      })

      const mainThis = this
      this.$store
        .dispatch('persons/setCurrentPerson', newPerson)
        .then(function() {
          mainThis.$router.push({
            name: 'PersonDetail',
            params: { id: 'mrn:person:' + newPerson.id }
          })
        })
    },
    selectAll() {
      if (
        this.selectedThings.length ===
        this.filteredThingsByLiveTrackingService.length
      ) {
        this.selectedThings = []
      } else {
        this.selectedThings = structuredClone(
          this.filteredThingsByLiveTrackingService
        )
      }
    },
    selectAllThingsEmergencyContact() {
      if (
        this.selectedThingsEmergencyContact.length ===
        this.filteredThingsByLiveTrackingService.length
      ) {
        this.selectedThingsEmergencyContact = []
      } else {
        this.selectedThingsEmergencyContact = structuredClone(
          this.filteredThingsByLiveTrackingService
        )
      }
    },
    async createContactEmergencyFromPerson() {
      const thingsList = this.selectedThingsEmergencyContact.map(e => e.uriId)
      if (thingsList.length) {
        const idContact = this.person.id
        const firstName = this.first_name
        const lastName = this.last_name

        const thingsOfThingsList = ThingsHelpers.splitArray(thingsList, 5)

        const promises = []

        for (let i = 0; i < thingsOfThingsList.length; i++) {
          promises.push(
            ThingsHelpers.createAndUpdateThingsFromEmergencyContact(
              idContact,
              firstName,
              lastName,
              thingsOfThingsList[i]
            )
          )
        }

        try {
          const responses = await Promise.allSettled(promises)
          responses.forEach(res => {
            if (res.status !== 'fulfilled')
              throw new Error(
                'Error al guardad las entidades con sus contactos de emergencia'
              )
          })
        } catch (e) {
          throw new Error(
            'Error al guardad las entidades con sus contactos de emergencia'
          )
        }
      }
    }
  },
  watch: {
    rolles: {
      handler(value) {
        if (value.length === 1) {
          this.roles.find(
            r => r.id === PersonsHelpers.ROL_ID.contact
          ).disabled = false
        } else {
          this.roles.find(
            r => r.id === PersonsHelpers.ROL_ID.contact
          ).disabled = true
        }
      },
      deep: true
    },
    identification_number() {
      this.personDuplicated = false
      this.errorMessage = ''
      this.offErrorMessageForContactEmergencyFields()
    },
    identification_type() {
      this.offErrorMessageForContactEmergencyFields()
    },
    email() {
      this.personDuplicated = false
      this.errorMessage = ''
    },
    selectedThings(value) {
      if (value.length > 0) this.errorThingsSelected = ''
      else this.errorThingsSelected = 'Debe seleccionar al menos una entidad'
    },
    selectedThingsEmergencyContact(value) {
      if (value.length > 0) {
        this.errorThingsSelectedEmergencyContact = ''
      } else {
        this.errorThingsSelectedEmergencyContact =
            'Debe seleccionar al menos una entidad'
      }
    }
  },
  computed: {
    ...mapGetters('persons', ['getPersons']),
    ...mapGetters('things', [
      'getThings',
      'filteredThingsByLiveTrackingService'
    ]),
    ...mapGetters(['isAdmin']),
    hasIbuttonService() {
      return this.getThings.some(thing =>
        thing.serviceList.some(
          service => service.name === 'mrn:service:ibutton'
        )
      )
    },
    filteredRoles() {
      if (this.hasIbuttonService) {
        return this.roles
      }
      // Excluir el rol de Conductor si no existe el servicio ibutton (id: 4)
      return this.roles.filter(role => role.id !== 4)
    },
    isNewPersonView() {
      return this.$route.name === 'NewPerson'
    },
    filteredProfiles() {
      if (this.user.isAdminSubFleet) {
        return this.profiles.filter(
          profile =>
            profile.text ===
              i18n.t(
                'fleet_management.persons.new_person.labels.card_data_profile_monitor'
              ) ||
            profile.text ===
              i18n.t(
                'fleet_management.persons.new_person.labels.card_data_profile_fleet_admin'
              )
        )
      } else {
        return this.profiles
      }
    },
    user() {
      return store.state.user
    },
    hasRoleContact() {
      return this.rolles.some(
        rol => rol.rol === PersonsHelpers.ROL_ID.emergencyContact
      )
    },
    selectedSomeThings() {
      return this.selectedThings.length > 0
    },
    selectedSomeThingsEmergencyContact() {
      return this.selectedThingsEmergencyContact.length > 0
    },
    icon() {
      if (this.selectedSomeThings || this.selectedSomeThingsEmergencyContact)
        return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    checkSingleNumberPhones() {
      const itemCount = {}
      const emergencyContact = this.rolles.find(
        el => el.rol === PersonsHelpers.ROL_ID.emergencyContact
      )

      emergencyContact?.rolContact.forEach(value => {
        const number = value.number
        number in itemCount
          ? (itemCount[number] = itemCount[number] + 1)
          : (itemCount[number] = 1)
      })

      const check = Object.values(itemCount).some(el => el > 1)

      return check
    }
  }
}
</script>

<style lang="scss" scoped>
.orange--text {
  color: var(--orange) !important;
}
.dialog-attention {
  border: 2px solid var(--orange);
}
.divider-dotted {
  border-width: 0;
  background-size: 6px 3px;
  background-repeat: repeat-x;
  background-position-y: bottom;
  background-image: radial-gradient(
    circle,
    rgba(0, 0, 0, 0.15) 0.05rem,
    transparent 1.5px
  );
  height: 3px;
}
</style>
